import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute({ children, role }) {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (role && currentUser.role !== role) {
    return <Navigate to="/" replace />;
  }

  return children || <Outlet />;
}
